
const PhotographySvg = () => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M91.5 89.5V125.5H37.5V89.5H91.5Z" stroke="#0085FF" />
      <path d="M91.5 49.5V85.5H37.5V49.5H91.5Z" stroke="#0085FF" />
      <path d="M91.5 9.5V45.5H37.5V9.5H91.5Z" stroke="#0085FF" />
      <path d="M37.5 0V5.5H91.5V0" stroke="#0085FF" />
      <path d="M25 0V128" stroke="#0085FF" />
      <path d="M103 0V128" stroke="#0085FF" />
      <path
        d="M30 121.5H33C33.8284 121.5 34.5 122.172 34.5 123V124C34.5 124.828 33.8284 125.5 33 125.5H30C29.1716 125.5 28.5 124.828 28.5 124V123C28.5 122.172 29.1716 121.5 30 121.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 113.5H33C33.8284 113.5 34.5 114.172 34.5 115V116C34.5 116.828 33.8284 117.5 33 117.5H30C29.1716 117.5 28.5 116.828 28.5 116V115C28.5 114.172 29.1716 113.5 30 113.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 105.5H33C33.8284 105.5 34.5 106.172 34.5 107V108C34.5 108.828 33.8284 109.5 33 109.5H30C29.1716 109.5 28.5 108.828 28.5 108V107C28.5 106.172 29.1716 105.5 30 105.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 97.5H33C33.8284 97.5 34.5 98.1716 34.5 99V100C34.5 100.828 33.8284 101.5 33 101.5H30C29.1716 101.5 28.5 100.828 28.5 100V99C28.5 98.1716 29.1716 97.5 30 97.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 89.5H33C33.8284 89.5 34.5 90.1716 34.5 91V92C34.5 92.8284 33.8284 93.5 33 93.5H30C29.1716 93.5 28.5 92.8284 28.5 92V91C28.5 90.1716 29.1716 89.5 30 89.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 121.5H99C99.8284 121.5 100.5 122.172 100.5 123V124C100.5 124.828 99.8284 125.5 99 125.5H96C95.1716 125.5 94.5 124.828 94.5 124V123C94.5 122.172 95.1716 121.5 96 121.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 113.5H99C99.8284 113.5 100.5 114.172 100.5 115V116C100.5 116.828 99.8284 117.5 99 117.5H96C95.1716 117.5 94.5 116.828 94.5 116V115C94.5 114.172 95.1716 113.5 96 113.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 105.5H99C99.8284 105.5 100.5 106.172 100.5 107V108C100.5 108.828 99.8284 109.5 99 109.5H96C95.1716 109.5 94.5 108.828 94.5 108V107C94.5 106.172 95.1716 105.5 96 105.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 97.5H99C99.8284 97.5 100.5 98.1716 100.5 99V100C100.5 100.828 99.8284 101.5 99 101.5H96C95.1716 101.5 94.5 100.828 94.5 100V99C94.5 98.1716 95.1716 97.5 96 97.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 89.5H99C99.8284 89.5 100.5 90.1716 100.5 91V92C100.5 92.8284 99.8284 93.5 99 93.5H96C95.1716 93.5 94.5 92.8284 94.5 92V91C94.5 90.1716 95.1716 89.5 96 89.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 81.5H99C99.8284 81.5 100.5 82.1716 100.5 83V84C100.5 84.8284 99.8284 85.5 99 85.5H96C95.1716 85.5 94.5 84.8284 94.5 84V83C94.5 82.1716 95.1716 81.5 96 81.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 73.5H99C99.8284 73.5 100.5 74.1716 100.5 75V76C100.5 76.8284 99.8284 77.5 99 77.5H96C95.1716 77.5 94.5 76.8284 94.5 76V75C94.5 74.1716 95.1716 73.5 96 73.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 65.5H99C99.8284 65.5 100.5 66.1716 100.5 67V68C100.5 68.8284 99.8284 69.5 99 69.5H96C95.1716 69.5 94.5 68.8284 94.5 68V67C94.5 66.1716 95.1716 65.5 96 65.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 81.5H33C33.8284 81.5 34.5 82.1716 34.5 83V84C34.5 84.8284 33.8284 85.5 33 85.5H30C29.1716 85.5 28.5 84.8284 28.5 84V83C28.5 82.1716 29.1716 81.5 30 81.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 73.5H33C33.8284 73.5 34.5 74.1716 34.5 75V76C34.5 76.8284 33.8284 77.5 33 77.5H30C29.1716 77.5 28.5 76.8284 28.5 76V75C28.5 74.1716 29.1716 73.5 30 73.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 65.5H33C33.8284 65.5 34.5 66.1716 34.5 67V68C34.5 68.8284 33.8284 69.5 33 69.5H30C29.1716 69.5 28.5 68.8284 28.5 68V67C28.5 66.1716 29.1716 65.5 30 65.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 57.5H33C33.8284 57.5 34.5 58.1716 34.5 59V60C34.5 60.8284 33.8284 61.5 33 61.5H30C29.1716 61.5 28.5 60.8284 28.5 60V59C28.5 58.1716 29.1716 57.5 30 57.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 49.5H33C33.8284 49.5 34.5 50.1716 34.5 51V52C34.5 52.8284 33.8284 53.5 33 53.5H30C29.1716 53.5 28.5 52.8284 28.5 52V51C28.5 50.1716 29.1716 49.5 30 49.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 41.5H33C33.8284 41.5 34.5 42.1716 34.5 43V44C34.5 44.8284 33.8284 45.5 33 45.5H30C29.1716 45.5 28.5 44.8284 28.5 44V43C28.5 42.1716 29.1716 41.5 30 41.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 33.5H33C33.8284 33.5 34.5 34.1716 34.5 35V36C34.5 36.8284 33.8284 37.5 33 37.5H30C29.1716 37.5 28.5 36.8284 28.5 36V35C28.5 34.1716 29.1716 33.5 30 33.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 25.5H33C33.8284 25.5 34.5 26.1716 34.5 27V28C34.5 28.8284 33.8284 29.5 33 29.5H30C29.1716 29.5 28.5 28.8284 28.5 28V27C28.5 26.1716 29.1716 25.5 30 25.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 17.5H33C33.8284 17.5 34.5 18.1716 34.5 19V20C34.5 20.8284 33.8284 21.5 33 21.5H30C29.1716 21.5 28.5 20.8284 28.5 20V19C28.5 18.1716 29.1716 17.5 30 17.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 9.5H33C33.8284 9.5 34.5 10.1716 34.5 11V12C34.5 12.8284 33.8284 13.5 33 13.5H30C29.1716 13.5 28.5 12.8284 28.5 12V11C28.5 10.1716 29.1716 9.5 30 9.5Z"
        stroke="#0085FF"
      />
      <path
        d="M30 1.5H33C33.8284 1.5 34.5 2.17157 34.5 3V4C34.5 4.82843 33.8284 5.5 33 5.5H30C29.1716 5.5 28.5 4.82843 28.5 4V3C28.5 2.17157 29.1716 1.5 30 1.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 57.5H99C99.8284 57.5 100.5 58.1716 100.5 59V60C100.5 60.8284 99.8284 61.5 99 61.5H96C95.1716 61.5 94.5 60.8284 94.5 60V59C94.5 58.1716 95.1716 57.5 96 57.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 49.5H99C99.8284 49.5 100.5 50.1716 100.5 51V52C100.5 52.8284 99.8284 53.5 99 53.5H96C95.1716 53.5 94.5 52.8284 94.5 52V51C94.5 50.1716 95.1716 49.5 96 49.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 41.5H99C99.8284 41.5 100.5 42.1716 100.5 43V44C100.5 44.8284 99.8284 45.5 99 45.5H96C95.1716 45.5 94.5 44.8284 94.5 44V43C94.5 42.1716 95.1716 41.5 96 41.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 33.5H99C99.8284 33.5 100.5 34.1716 100.5 35V36C100.5 36.8284 99.8284 37.5 99 37.5H96C95.1716 37.5 94.5 36.8284 94.5 36V35C94.5 34.1716 95.1716 33.5 96 33.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 25.5H99C99.8284 25.5 100.5 26.1716 100.5 27V28C100.5 28.8284 99.8284 29.5 99 29.5H96C95.1716 29.5 94.5 28.8284 94.5 28V27C94.5 26.1716 95.1716 25.5 96 25.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 17.5H99C99.8284 17.5 100.5 18.1716 100.5 19V20C100.5 20.8284 99.8284 21.5 99 21.5H96C95.1716 21.5 94.5 20.8284 94.5 20V19C94.5 18.1716 95.1716 17.5 96 17.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 9.5H99C99.8284 9.5 100.5 10.1716 100.5 11V12C100.5 12.8284 99.8284 13.5 99 13.5H96C95.1716 13.5 94.5 12.8284 94.5 12V11C94.5 10.1716 95.1716 9.5 96 9.5Z"
        stroke="#0085FF"
      />
      <path
        d="M96 1.5H99C99.8284 1.5 100.5 2.17157 100.5 3V4C100.5 4.82843 99.8284 5.5 99 5.5H96C95.1716 5.5 94.5 4.82843 94.5 4V3C94.5 2.17157 95.1716 1.5 96 1.5Z"
        stroke="#0085FF"
      />
    </svg>
  );
};

export default PhotographySvg;
